import {
  REDIRECT,
  CHECK_CAMPAIGN_ITEM,
  CREATE_EVENT,
  LOCATE_PAGE_UNLOADED
} from "../constants/common.action.types";
import assetService from "../../services/asset.service";

export const redirect = () => {
  return { type: REDIRECT };
};

export const checkCampaignItem = key => {
  const payload = assetService.checkCampaignItem(key);
  return { type: CHECK_CAMPAIGN_ITEM, payload, key };
};

export const createEvent = (key, type, value) => {
  const payload = assetService.createCampaignItemEvent(key, type, value);
  return { type: CREATE_EVENT, payload };
};

export const unloadLocate = () => {
  return { type: LOCATE_PAGE_UNLOADED };
};
